import { Container, TableCell, TableRow } from '@mui/material';
import { CashFlowReportDto, CFD_TYPES } from '@sr/dto';

import { ErrorBanner } from 'shared/ui/error-banner';
import { GridLayout } from 'shared/ui/grid-layout';
import { LoadingBanner } from 'shared/ui/loading-banner';
import PriceSpan from 'shared/ui/price-span';

interface CashFlowGridProps {
  collection: CashFlowReportDto[];
  isLoading: boolean;
  error: string | undefined;
}
const columns = ['Направление', 'Статья движения денежных средств', 'Приход', 'Расход', 'Итого'];

export const CashFlowGrid = ({ collection, isLoading, error }: CashFlowGridProps) => {

  if (error)
    return (
      <Container>
        <ErrorBanner errorMessage={error} />
      </Container>
    );
  if (isLoading) {
    return <LoadingBanner />;
  }
    
  const sums = collection.reduce(
    (acc, row) => ({
      income: acc.income + row.income,
      expense: acc.expense + row.expense
    }),
    { income: 0, expense: 0 }
  );
  const round2 = (x: number) => Math.round(x * 100) / 100;
  // Итого = приход − расход
  const totals = { income: round2(sums.income), expense: round2(sums.expense), total: round2(sums.income - sums.expense) };

  return (
    <>
      <GridLayout
        columns={columns}
        items={collection}
        isLoading={isLoading}
        error={error}
        footer={() => <CashFlowTotal {...totals} />}
        itemRender={(row) => <CashFlowRow row={row} />}
        noItemsText="Нет отчёта за выбранный период" />
    </>
  );

};
const CashFlowRow = ({ row }: { row: CashFlowReportDto }) => {
  return (
    <TableRow>
      <TableCell align="left">{CFD_TYPES[row.cashflow.direction]}</TableCell>
      <TableCell align="left">{row.cashflow.title}</TableCell>
      <TableCell align="center"><PriceSpan price={row.income} size="small" /></TableCell>
      <TableCell align="center"><PriceSpan price={row.expense} size="small" /></TableCell>
      <TableCell align="center"><PriceSpan price={row.total} size="small" /></TableCell>
    </TableRow>
  );
};

const CashFlowTotal = ({ income, expense, total }: { income: number; expense: number; total: number }) => {
  return (   
    <TableRow>
      <TableCell align="left" colSpan={2}>
        <b>ИТОГО:</b>
      </TableCell>
      <TableCell align="center"><PriceSpan price={income} size="small" /></TableCell>
      <TableCell align="center"><PriceSpan price={expense} size="small" /></TableCell>
      <TableCell align="center"><PriceSpan price={total} size="small" /></TableCell>
    </TableRow>

  );
};
